import React from 'react';
import clsx from 'clsx';

import scss from './MediaSourceSwitchButton.module.scss';

function MediaSourceSwitchButton({ icon: Icon, label, isActive, onClick }) {
  return (
    <button
      type='button'
      role='radio'
      aria-checked={isActive}
      className={clsx(scss.button, isActive && scss.active)}
      onClick={onClick}
      aria-label={label}>
      <Icon className={scss.icon} />
    </button>
  );
}

export default MediaSourceSwitchButton;
